import { FlexContainer } from '../../containers/ContentContainers/FlexContainer';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  DialogActions,
  useTheme,
  ListItem,
  List,
} from '@mui/material';
import { buildInfo } from 'toolkit/environment/build-info';
import { getEnvironment } from 'toolkit/environment/environment/environment';

interface BuildInfoDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const BuildInfoDialog = ({ open, setOpen }: BuildInfoDialogProps) => {
  const theme = useTheme();

  const feBuildTime =
    buildInfo.dateTime === 'local'
      ? 'local'
      : new Date(buildInfo.dateTime).toLocaleString();
  const feGitHash = buildInfo.gitHash;

  const beBuildTime =
    getEnvironment().backendBuildInfo.dateTime === 'local'
      ? 'local'
      : new Date(getEnvironment().backendBuildInfo.dateTime).toLocaleString();
  const beGitHash = getEnvironment().backendBuildInfo.gitHash;

  function handleClose() {
    setOpen(false);
  }

  function handleCopyBuildInfo() {
    void navigator.clipboard.writeText(
      [
        'Frontend build time: ' + feBuildTime,
        'Frontend git hash: ' + feGitHash,
        'Backend build time: ' + beBuildTime,
        'Backend git hash: ' + beGitHash,
      ].join('\n')
    );
    handleClose();
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Build info</DialogTitle>
      <DialogContent>
        <FlexContainer direction="column" gap={1} padding="0px 24px 16px">
          <Typography component="div" variant="bodyLarge">
            Frontend build info:
          </Typography>
          <List>
            <ListItem>
              <Typography variant="bodyMedium">
                Build Time: {feBuildTime}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="bodyMedium">
                Git Hash: {feGitHash}
              </Typography>
            </ListItem>
          </List>

          <Typography component="div" variant="bodyLarge">
            Server build info:
          </Typography>
          <List>
            <ListItem>
              <Typography variant="bodyMedium">
                Build Time: {beBuildTime}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="bodyMedium">
                Git Hash: {beGitHash}
              </Typography>
            </ListItem>
          </List>
        </FlexContainer>
      </DialogContent>
      <DialogActions sx={{ borderTop: `1px solid ${theme.palette.divider}` }}>
        <Button onClick={handleClose}>Close</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCopyBuildInfo}
        >
          Copy build info
        </Button>
      </DialogActions>
    </Dialog>
  );
};
